// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import UpdateImportNameIndexPage, {
  useUpdateImportName,
} from '../../../../components/UpdateImportName/UpdateImportName';
import useFormikOrchestration from '../../../../components/useFormikOrchestration';
import { ProgressIndicator, useLink } from './_config';

/**
 * Renders the page where import name can be edited
 * @param {object} props
 */
export default function Name({ match }) {
  const link = useLink('name');
  const history = useHistory();
  const props = useUpdateImportName({
    workspaceId: match.params.workspaceId,
    importId: match.params.importId,
  });
  const { triggerSubmit, setFormikContext, isValid } = useFormikOrchestration();

  async function handleSubmit({ name }) {
    const result = await props.updateDataImportName({ name });
    if (!result?.error) history.push(link.next());
  }

  return (
    <Layout>
      <ProgressIndicator step="uploadFile" />
      <PageHeader>
        <PageTitle>
          <Trans>Name your import</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>This is how you will identify this import.</Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <UpdateImportNameIndexPage
          {...props}
          setFormikContext={setFormikContext}
          onSubmit={handleSubmit}
        />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton onClick={triggerSubmit} disabled={!isValid} />
      </Footer>
    </Layout>
  );
}
